import React from "react";

export const complexityColors = {
  low: "success",
  medium: "warning",
  high: "error",
} as const;

export const SERVICE_TYPE_COLORS: Record<
  string,
  "primary" | "secondary" | "info" | "warning"
> = {
  static: "primary",
  server: "primary",
  stateful: "secondary",
  scheduler: "info",
  cronjob: "warning",
};

export function formatDeploymentMode(mode: string): string {
  return mode.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
}

export function formatStackConfigKey(key: string): string {
  const labels: Record<string, string> = {
    frontend: "Frontend",
    backend: "Backend",
    database: "Database",
    cache: "Cache",
    messageQueue: "Message Queue",
    ingestion: "Ingestion",
    processing: "Processing",
    tableFormat: "Table Format",
    catalog: "Catalog",
    queryEngine: "Query Engine",
    orchestration: "Orchestration",
    biTool: "BI Tool",
    sourceType: "Source Type",
    olapEngine: "OLAP Engine",
  };
  return (
    labels[key] ||
    key.replace(/([A-Z])/g, " $1").replace(/^./, (l) => l.toUpperCase())
  );
}

export function formatStackConfigValue(
  value: string | null | undefined,
): string {
  if (!value || value === "null" || value === "none") return "None";
  return value.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
}

export const headerStyle: React.CSSProperties = {
  padding: "12px 16px",
  textAlign: "left",
  fontWeight: 600,
};

export const cellStyle: React.CSSProperties = {
  padding: "12px 16px",
};
